import MxButton2 from "@rf-l1/buttons/MxButton2";
import { memo } from "react";
import { useMemo } from "react";
import { Badge } from "@mui/material";
import { IconFilter } from "@tabler/icons-react";
import useFormWatch from "@rf-hooks/useFormWatch";

interface MxListButtonFilterProps {
  /** Callback function to open the filters modal */
  handleOpenModalFilters: () => void;
  /** Number of active filters to display in the badge */
  countFilters: number;
}

/**
 * A button component that displays the number of active filters and opens a filter modal when clicked.
 *
 * @component
 * @example
 * ```tsx
 * <MxListButtonFilter
 *   handleOpenModalFilters={() => setShowFilters(true)}
 *   countFilters={3}
 * />
 * ```
 *
 * @remarks
 * - Requires react-hook-form context to be available in the component tree
 * - Displays a badge with the count of active filters
 * - Uses MUI Badge and MxButton2 components
 *
 * @param {MxListButtonFilterProps} props - Component props
 * @returns {React.ReactNode} A button with filter count badge
 */
const MxListButtonFilter = memo(
  ({ handleOpenModalFilters, countFilters }: MxListButtonFilterProps) => {
    return (
      <Badge
        badgeContent={countFilters}
        sx={{
          "& .MuiBadge-badge": {
            backgroundColor: "grey.400",
            color: "white"
          }
        }}
      >
        <MxButton2
          testId="filters-button"
          children="Filtros"
          onClick={handleOpenModalFilters}
          endIcon={<IconFilter size={16} stroke={3} color="white" />}
          variant="contained"
        />
      </Badge>
    );
  }
);
export default MxListButtonFilter;

MxListButtonFilter.displayName = "MxListButtonFilter";
